import React from 'react'
import { FaInfo } from 'react-icons/fa'
import { BaseStepCard, StepHeader, StepContent } from './StepCard'
import { ValueBox, gradients } from '../styles'
import { Model } from '../../../../types/models/model'

interface ModelInfoCardProps {
  model: Model | undefined
}

export const ModelInfoCard: React.FC<ModelInfoCardProps> = ({ model }) => {
  return (
    <BaseStepCard>
      <StepHeader $gradient={gradients.info}>
        Model Information
        <FaInfo />
      </StepHeader>
      <StepContent>
        <ValueBox>
          <div className="label">Base</div>
          <div className="value">AG</div>
        </ValueBox>
        <ValueBox>
          <div className="label">Architecture</div>
          <div className="value">Yolo V8</div>
        </ValueBox>
        <ValueBox>
          <div className="label">Status</div>
          <div className="value">{model?.state || 'Not Started'}</div>
        </ValueBox>
      </StepContent>
    </BaseStepCard>
  )
}
